import { useLocation } from 'react-router';

const useWithLocation = <T>(
    fn: (locations: ReturnType<typeof useLocation>) => T
): T => {
    const location = useLocation();

    return fn(location);
};

export default useWithLocation;
